export const DESIGN_ICON_LIMIT = 3
export const ICON_SMALL_SIZE = 20
export const ICON_MEDIUM_SIZE = 24
export const MEDIUM_SIZE = 'MEDIUM_SIZE'
export const SMALL_SIZE = 'SMALL_SIZE'
